export const iconFontAwesomeCampingBinoculars = (
	<i className="fa-solid fa-binoculars"></i>
);
